export function wrapSaveToCache<Type>(obj: any, updateFunctionName: string, cacheKeyPostfix?: string): void {
    const originalUpdateFunction: (data: Partial<Type>) => Type = obj[updateFunctionName];

    function wrappedUpdateValues(data: Partial<Type>): Type {
        const newData = originalUpdateFunction.call(obj, data);
        window.localStorage.setItem(getCacheKey(cacheKeyPostfix), JSON.stringify(newData));
        return newData;
    }

    obj[updateFunctionName] = wrappedUpdateValues;
}

export function getCachedData<Type>(formId?: string): Type | null {
    const cachedString = window.localStorage.getItem(getCacheKey(formId));
    return cachedString ? JSON.parse(cachedString) : null;
}

export function clearCache(cacheKeyPostfix?: string) {
    window.localStorage.removeItem(getCacheKey(cacheKeyPostfix));
}

function getCacheKey(cacheKeyPostfix?: string): string {
    return `form_${window.location.pathname}_${cacheKeyPostfix}`;
}
